import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home/home.vue'
import solution from '../views/solution/solution.vue'
import product from '../views/product/product.vue'
import about from '../views/about/about.vue'


Vue.use(VueRouter)

export default new VueRouter({
  linkActiveClass:"active",
  // mode:"history",//去掉#
  routes: [
    {
      path: '/index',
      component: home
    },
    {
      path: '/solution',
      component: solution
    },
    {
      path: '/product',
      component: product
    },
    {
      path: '/about',
      component: about
    },
    //直接跳转到home页
    {
      path: '/',
      redirect: '/index'
    }

  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js